import { createSelector } from "@reduxjs/toolkit";

export default createSelector(
    ({ map }) => map.general.mode.name === "view",
    ({ map }) => map.values.global.present.lights,
    ({ map }) => map.values.mode.present.lights,
    (isViewMode, globalLights, modeLights) =>
        isViewMode ? globalLights : modeLights,
);
